import { render } from "./SidelinkList.vue?vue&type=template&id=c4d01152&scoped=true"
import script from "./SidelinkList.vue?vue&type=script&lang=js"
export * from "./SidelinkList.vue?vue&type=script&lang=js"

import "./SidelinkList.vue?vue&type=style&index=0&id=c4d01152&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/acnh-tracker/acnh-tracker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4d01152"]])

export default __exports__